/* eslint-disable react-hooks/exhaustive-deps */
import { KTSVG } from '../../_metronic/helpers'
import React, { useState, useEffect, useContext } from 'react'
// import { Table } from 'react-bootstrap-v5';
import DataTable from '../components/DataTable'
import Swal from 'sweetalert2'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import Select from 'react-select'
import { Link } from 'react-router-dom';
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Modal from 'react-bootstrap/Modal';
import { AppContext } from '../context/AppContext';


const ItemGlobalRating = () => {
    const { currentUser } = useContext(AppContext);

    // const [entity, setEntity] = useState('');
    const [newData, setNewData] = useState({});
    const [items, setItems] = useState([]);
    const [item, setItem] = useState({ label: 'Select Item', value: '' });
    const [itemCategories, setItemCategories] = useState([]);
    const [itemCategory, setItemCategory] = useState({ label: 'Select Item Category', value: '' });
    const [itemRate, setItemRate] = useState(null);
    const [effectiveDate, setEffectiveDate] = useState('');
    const [reason, setReason] = useState('');
    const [loading, setLoading] = useState(false);
    const [historyModalShow, setHistoryModalShow] = useState(false);
    const [historyItemId, setHistoryItemId] = useState<number | null>(null);
    const [historyItemName, setHistoryItemName] = useState<string>('');

    useEffect(() => {
        getItemCategories();
    }, [])

    const getItemCategories = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'allItemCategories',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let itemObj = resp.map((item: any) => {
                    item.label = item.category_name;
                    item.value = item.id_item_categories;
                    return item
                })
                setItemCategories(itemObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }
    const getItems = (idCategories: number) => {
        fetch(
            process.env.REACT_APP_API_URL + 'allItemsGlobalRating?idCategories=' + idCategories,
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let itemObj = resp.map((item: any) => {
                    item.label = item.item_name + ' - ID # ' + item.id_items;
                    item.value = item.id_items;
                    return item
                })
                setItems(itemObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const handleItemCategoryChange = (itemCategory: any) => {
        console.log(itemCategory)
        setItemCategory(itemCategory);
        getItems(itemCategory.value);
    }

    const handleItemChange = (item: any) => {
        setItem(item);
        setItemRate(item.rate);
    }

    const submitMergeRequest = async (event: any) => {
        event.preventDefault()
        const confirm = await Swal.fire({
            title: 'Are you sure to set this rate??',
            text: "You can't revert theis action",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes, Set it!',
        })
        if (confirm.value) {
            setLoading(true);
            const postData = {
                rate: itemRate,
                idItems: item.value,
                effective_date: effectiveDate ?? '',
                reason: reason ?? '',
            }
            console.log('Submitting payload:', JSON.stringify(postData));
            const requestOptions = postRequestOptions(postData)
            try {
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}item/set-global-rate`,
                    requestOptions
                )
                let respData = await response.json()
                if (respData.success === true) {
                    const successMsg = respData.successMessage
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: successMsg,
                    })

                    setNewData({ id: Date.now() });
                    // Reset form
                    setItem({ label: 'Select Item', value: '' });
                    setItemRate(null);
                    setEffectiveDate('');
                    setReason('');

                } else {
                    const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        html: errorsMessage,
                    })
                }
                setLoading(false);
            } catch (error) {
                console.log(error, 'catch the hoop')
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'An error occurred while submitting. Please try again.',
                })
                setLoading(false);
            }
        }
    }

    const handleShowHistory = (row: any) => {
        setHistoryItemId(row.id); // id from main list = id_item_global_rates
        setHistoryItemName(row.itemName || '');
        setHistoryModalShow(true);
    }

    const handleCloseHistoryModal = () => {
        setHistoryModalShow(false);
    }

    const handleUpdateProduction = async (row: any) => {
        const confirm = await Swal.fire({
            title: 'Do you really want to update the Production data?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes, Update it!',
        })

        if (confirm.value) {
            setLoading(true);
            const postData = {
                idItemGlobalRates: row.id,
            }
            const requestOptions = postRequestOptions(postData)
            try {
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}itemGlobalRate/updateProduction`,
                    requestOptions
                )
                let respData = await response.json()
                if (respData.success === true) {
                    const successMsg = respData.successMessage
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: successMsg,
                    })

                    setNewData({ id: Date.now() });
                } else {
                    const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        html: errorsMessage,
                    })
                }
                setLoading(false);
            } catch (error) {
                console.log(error, 'catch the hoop')
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'An error occurred while updating. Please try again.',
                })
                setLoading(false);
            }
        }
    }

    const handleItemRateChange = (e: any) => {
        setItemRate(e.target.value);
    }

    const handleEffectiveDateChange = (e: any) => {
        setEffectiveDate(e.target.value);
    }

    const handleReasonChange = (e: any) => {
        setReason(e.target.value);
    }

    const columns = [
        { value: 'id', title: 'Id', style: { textAlign: 'center' } },
        { value: 'itemName', title: 'Item Name', style: { textAlign: 'left' } },
        { value: 'itemCode', title: 'Item Code', style: { textAlign: 'left' } },
        { value: 'categoryName', title: 'Item Category', style: { textAlign: 'left' } },
        { value: 'rate', title: 'Rate', style: { textAlign: 'center' } },
        { value: 'effectiveDate', title: 'Effective Date', style: { textAlign: 'left' } },
        { value: 'reason', title: 'Reason', style: { textAlign: 'left' } },
        { value: 'createdBy', title: 'Recorded By', style: { textAlign: 'left' } },
        { value: 'createdAt', title: 'Recorded At', style: { textAlign: 'left' } },
        {
            value: 'action', title: 'Action', style: { textAlign: 'left', whiteSpace: 'nowrap' }, hasActionsComponent: true, actionsComponent: ((row: any) => {
                return (
                    <>
                        <button
                            type="button"
                            className="btn btn-light-primary btn-sm p-2"
                            onClick={() => handleShowHistory(row)}
                        >
                            <KTSVG
                                path='/media/svg/icons/Text/Bullet-list.svg'
                                className='svg-icon-5 svg-icon'
                            />&nbsp;Update History
                        </button>
                        {row.effectiveDateRun === 'No' && currentUser && currentUser.id === 3 && (
                            <button
                                type="button"
                                className="btn btn-light-warning btn-sm p-2 ms-2"
                                onClick={() => handleUpdateProduction(row)}
                                disabled={loading}
                            >
                                <KTSVG
                                    path='/media/svg/icons/General/Update.svg'
                                    className='svg-icon-5 svg-icon'
                                />&nbsp;Update Production
                            </button>
                        )}
                    </>
                )
            })
        }
    ]

    const filters = {
        id: {
            filterType: 'like',
            filterValue: '',
        },
        itemName: {
            filterType: 'like',
            filterValue: '',
        },
        itemCode: {
            filterType: 'like',
            filterValue: '',
        },
        categoryName: {
            filterType: 'like',
            filterValue: '',
        },
        rate: {
            filterType: 'like',
            filterValue: '',
        },
        effectiveDate: {
            filterType: 'like',
            filterValue: '',
        },
        reason: {
            filterType: 'like',
            filterValue: '',
        },
        createdBy: {
            filterType: 'like',
            filterValue: '',
        },
        createdAt: {
            filterType: 'like',
            filterValue: '',
        },
       
    }

    const url = process.env.REACT_APP_API_URL + 'itemGlobalRate/dt'

    const historyColumns = [
        { value: 'id', title: 'Id', style: { textAlign: 'center' } },
        { value: 'itemName', title: 'Item Name', style: { textAlign: 'left' } },
        { value: 'itemCode', title: 'Item Code', style: { textAlign: 'left' } },
        { value: 'oldRate', title: 'Old Rate', style: { textAlign: 'center' } },
        { value: 'newRate', title: 'New Rate', style: { textAlign: 'center' } },
        { value: 'effectiveDate', title: 'Effective Date', style: { textAlign: 'left' } },
        { value: 'reason', title: 'Reason', style: { textAlign: 'left' } },
        { value: 'createdBy', title: 'Changed By', style: { textAlign: 'left' } },
        { value: 'createdAt', title: 'Changed At', style: { textAlign: 'left' } },
    ];

    const historyFilters = {
        id: {
            filterType: 'like',
            filterValue: '',
        },
        itemName: {
            filterType: 'like',
            filterValue: '',
        },
        itemCode: {
            filterType: 'like',
            filterValue: '',
        },
        oldRate: {
            filterType: 'like',
            filterValue: '',
        },
        newRate: {
            filterType: 'like',
            filterValue: '',
        },
        effectiveDate: {
            filterType: 'like',
            filterValue: '',
        },
        reason: {
            filterType: 'like',
            filterValue: '',
        },
        createdBy: {
            filterType: 'like',
            filterValue: '',
        },
        createdAt: {
            filterType: 'like',
            filterValue: '',
        },
    };

    const historyUrl = process.env.REACT_APP_API_URL + 'itemGlobalRateHistory/dt'

    // const rollBackMerge = async (id: number) => {


    //     const confirm = await Swal.fire({
    //         title: 'Are you sure to Roll Back?',
    //         text: "You can't revert theis action",
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonColor: '#ec008c',
    //         cancelButtonText: 'Cancel',
    //         confirmButtonText: 'Yes, Roll Back!',
    //     })
    //     if (confirm.value) {

    //         const requestOptions = postRequestOptions()
    //         try {
    //             let response = await fetch(
    //                 `${process.env.REACT_APP_API_URL}merge-entity-rollback/${id}`,
    //                 requestOptions
    //             )
    //             let respData = await response.json()
    //             if (respData.success === true) {
    //                 const successMsg = respData.successMessage
    //                 Swal.fire({
    //                     icon: 'success',
    //                     title: 'Success',
    //                     text: successMsg,
    //                 })

    //                 setNewData({ id: Date.now() });
    //             } else {
    //                 const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
    //                 Swal.fire({
    //                     icon: 'error',
    //                     title: 'Error',
    //                     html: errorsMessage,
    //                 })
    //             }
    //             // setSubmitDisable(false);
    //             // setLoading(false);
    //         } catch (error) {
    //             console.log(error, 'catch the hoop')
    //             // setSubmitDisable(false);
    //             // setLoading(false);
    //         }
    //     }

    // };

    return (

        <div className="card card-custom">
            <div className="card-header">
                <div className="card-title">
                    <KTSVG
                        path='/media/icons/duotune/coding/cod001.svg'
                        className='svg-icon-1 svg-icon-primary'
                    />
                    <span className="text fw-bolder" style={{ marginLeft: "10px" }}>
                        Item Global Rating
                    </span>
                </div>
            </div>

            <div className="ml-12">
                <div className="card-body">

                    <Tabs
                        defaultActiveKey="new-rate-setting"
                        id="uncontrolled-tab-example"
                        className="mb-3 ml-3 mr-3"
                    >
                        <Tab eventKey="new-rate-setting" title="Set New Rate">
                            {/* <pre>{JSON.stringify(order, null, 2)}</pre> */}
                            <form onSubmit={submitMergeRequest}>

                                {/* <div className="form-group row">
                            <label htmlFor="idItems" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Entity <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <select className="form-select form-select-sm" id="entity" name="entity" onChange={handleEntityChange} value={entity}>
                                    <option value="">Select Entity</option>
                                    <option value={'Item'}>Item</option>
                                    <option value={'Client'}>Client</option>
                                    <option value={'Product'}>Product</option>
                                </select>
                            </div>
                        </div> */}


                                <div className="form-group row">
                                    <label htmlFor="idItems" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Item Category<span className="required text-danger"></span></label>
                                    <div className="col-lg-5">
                                        <Select
                                            value={itemCategory}
                                            onChange={handleItemCategoryChange}
                                            options={itemCategories}
                                            menuPosition="fixed"
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="idItems" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Item <span className="required text-danger"></span></label>
                                    <div className="col-lg-5">
                                        <Select
                                            value={item}
                                            onChange={handleItemChange}
                                            options={items}
                                            menuPosition="fixed"
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="idLeads" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>New Rate  <span className="required text-danger"></span></label>
                                    <div className="col-lg-5">
                                        <input type='number' step='any' name='globalRate' value={itemRate || ''} className='form-control' onChange={handleItemRateChange}></input>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="effectiveDate" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Effective Date  <span className="required text-danger"></span></label>
                                    <div className="col-lg-5">
                                        <input type='date' name='effectiveDate' value={effectiveDate} className='form-control' onChange={handleEffectiveDateChange}></input>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="reason" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Reason  <span className="required text-danger"></span></label>
                                    <div className="col-lg-5">
                                        <textarea name='reason' value={reason} className='form-control' onChange={handleReasonChange} rows={3}></textarea>
                                    </div>
                                </div>



                                <div className="row mt-4">
                                    <div className="col-12 text-center">
                                        <button type="submit" className="btn btn-sm btn-success me-2" disabled={loading}>
                                            {loading && (
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            )}
                                            {loading ? 'Submitting...' : 'Submit'}
                                        </button>
                                        <Link to='/dashboard' type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                                    </div>
                                </div>


                            </form>
                        </Tab>
                        <Tab eventKey="rate-list" title="Rate List History">
                            <DataTable url={url} columns={columns} filters={filters} newData={newData} defaultSortedColumn="updatedAt" />
                        </Tab>
                    </Tabs>

                </div>
            </div>

            <Modal show={historyModalShow} onHide={handleCloseHistoryModal} fullscreen>
                <Modal.Header closeButton>
                    <Modal.Title>Item Rate Update History {historyItemName ? `- ${historyItemName}` : ''}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {historyItemId ? (
                        <DataTable
                            url={historyUrl}
                            columns={historyColumns}
                            filters={historyFilters}
                            additionalPostData={{ idItemGlobalRates: historyItemId }}
                        />
                    ) : (
                        <p>No item selected.</p>
                    )}
                </Modal.Body>
            </Modal>
        </div >

    )
}

export default ItemGlobalRating
